"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MPUProgressbar = void 0;
var anime_es_js_1 = __importDefault(require("animejs/lib/anime.es.js"));
var MPUProgressbar = /** @class */ (function () {
    function MPUProgressbar(selector) {
        var _this = this;
        this.elements = document.querySelectorAll(selector);
        if (this.elements.length === 0) {
            throw new Error("No elements found with selector \"".concat(selector, "\"."));
        }
        // Füge einen Scroll-Event-Listener hinzu
        window.addEventListener('scroll', function () { return _this.updateProgress(); });
        // Initialisiere die Progressbars
        this.updateProgress();
    }
    MPUProgressbar.prototype.updateProgress = function () {
        this.elements.forEach(function (element) {
            var progressBar = element.querySelector('.progress-bar');
            if (!progressBar) {
                return;
            }
            // Berechne die Position des Elements im Verhältnis zum Viewport
            var rect = element.getBoundingClientRect();
            var windowHeight = window.innerHeight;
            // Berechne den Fortschritt basierend auf der Position im Viewport
            var scrollPercent = 0;
            if (rect.top < windowHeight && rect.bottom >= 0) {
                var visibleHeight = Math.min(windowHeight, rect.bottom) - Math.max(0, rect.top);
                scrollPercent = (visibleHeight / rect.height) * 100;
            }
            // Aktualisiere die Breite der Progressbar mit einer Animation
            (0, anime_es_js_1.default)({
                targets: progressBar,
                width: "".concat(scrollPercent, "%"),
                duration: 500, // Dauer der Animation
                easing: 'easeOutQuad'
            });
            // Entferne den Textinhalt der Progressbar
            progressBar.textContent = '';
        });
    };
    return MPUProgressbar;
}());
exports.MPUProgressbar = MPUProgressbar;
